/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type CampaignUserRegisterStatus = typeof CampaignUserRegisterStatus[keyof typeof CampaignUserRegisterStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignUserRegisterStatus = {
  NOT_REGISTERED: 'NOT_REGISTERED',
  REGISTERED: 'REGISTERED',
} as const;
